<template>
	<div id="app" class="main">
		<xw-header></xw-header>
		<xw-login></xw-login>
		<xw-login-sex></xw-login-sex>
		<xw-login-year></xw-login-year>
		<xw-login-company></xw-login-company>
		<xw-login-industry></xw-login-industry>
		<xw-login-password></xw-login-password>
		<div id="main-content" class="main-content xw-scrollbar">
			<transition name="el-zoom-in-center">
				<router-view></router-view>
			</transition>
		</div>

        <!-- 右侧菜单 -->
        <nav-right></nav-right>
        <!--在线反馈-->
        <feedback></feedback>
	</div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import util from './store/utils'
	import xwHeader from './components/Header.vue'
	import xwLogin from './view/login/Login.vue'
	import xwLoginSex from './view/login/LoginSex.vue'
	import xwLoginYear from './view/login/LoginYear.vue'
	import xwLoginCompany from './view/login/LoginCompany.vue'
	import xwLoginIndustry from './view/login/LoginIndustry.vue'
    import xwLoginPassword from './view/login/LoginPassword.vue'
    import navRight from './components/NavRight'
    import Feedback from './components/Feedback'
	export default {
        components: {
            xwHeader,
            xwLogin,
            xwLoginSex,
            xwLoginYear,
            xwLoginCompany,
            xwLoginIndustry,
            xwLoginPassword,
            navRight,
            Feedback
        },
		data () {
			return {
			}
		},
        computed: {
            ...mapState(['user']),
        },
        async created() {
            if(this.$route.query.id){
                window.sessionStorage.setItem('id',this.$route.query.id)
            }
            if (util.runAuth('get')) {
                this.getUser();
                this.getTypeLog();
                if(this.user.wxopenid2){
                    await this.addShareLog({conditionType:2});
                }

            } else {
                this.logoutUser();
            }
        },
        methods: {
            ...mapActions(['getUser', 'logoutUser']),
            ...mapActions('welfare',[ 'addShareLog','getTypeLog'])
        }
	}
</script>
<style lang="scss" scoped>
	.main {
		width: 100%;
		height: 100%;
	}
	.main-content {
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// app/App.vue